import React from "react"
import Text from "../components/Text"
import VisibilitySensor from "../animations/VisibilitySensor"
import {
  Box,
  Container,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import Picture from "../components/Picture"
import Module from "../components/Module"
import CtaButton from "../components/CtaButton"

const useStyles = makeStyles(theme => ({
  package: {
    padding: "32px",
  },
  border: {
    border: "1px solid #f2f2f2",
    [theme.breakpoints.down("sm")]: {
      border: 0,
    },
  },
  imageBorder: {
    borderRight: "1px solid #f2f2f2",
    [theme.breakpoints.down("sm")]: {
      border: 0,
    },
  },
  title: {
    padding: "40px 0",
  },
  descTitle: {
    fontWeight: 600,
    fontSize: "25px",
    color: "#662482",
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
      fontSize: "30px",
    },
  },
  descSubTitle: {
    fontWeight: 500,
    fontSize: "14px",
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
      fontSize: "16px",
    },
  },
  free_shipping_text: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#662482",
    textAlign: "right",
    width: "100%",
    textTransform: "uppercase",
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
  },
  deliveryText: {
    fontSize: "16px",
    fontWeight: "400",
  },
  deliveryTextSpecial: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#662482",
    textWrapMode: "nowrap",
  },
  priceText: {
    fontSize: "18px",
  },
  priceContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    textAlign: "right",
    textWrapMode: "nowrap",
    fontSize: "18px",
    justifyContent: "end",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row",
    },
  },
  ctaButton: {
    width: "100%",
    justifyContent: "space-between",
    [theme.breakpoints.up("lg")]: {
      width: "335px",
    },
  },
  disclaimer: {
    fontSize: "12px",
    color: "#808080",
    lineHeight: "14.76px",
  },
}))

const PackageV3Module = props => {
  const classes = useStyles()
  const theme = useTheme()
  const {
    image,
    image_mobile,
    title,
    package_title,
    package_subtitle,
    free_shipping_text,
    disclaimer,
    item,
    button_cta,
    repo,
  } = props

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <Module className={classes.package}>
      <VisibilitySensor>
        <>
          <Container fixed>
            <Grid item xs={12} md={12}>
              <Text
                className={classes.title}
                variant="titleXXXL"
                component="h3"
                align="center"
                weight="bold"
                overline
              >
                {title.field_value}
              </Text>
            </Grid>

            <Box>
              {isMobile && (
                <Box paddingY={2}>
                  <Box className={classes.descTitle}>
                    {package_title.field_value}
                  </Box>
                  {package_subtitle?.field_value && (
                    <Box className={classes.descSubTitle}>
                      {package_subtitle.field_value}
                    </Box>
                  )}
                </Box>
              )}
              <Grid container className={classes.border}>
                <Grid item xs={12} md={6} className={classes.imageBorder}>
                  <Box p={{ xs: 2, md: 8 }}>
                    <div className="img-content h-100 w-100 d-flex justify-content-center align-items-center">
                      <Picture
                        src={
                          isMobile
                            ? image_mobile?.field_value?.src ||
                              image?.field_value?.src
                            : image?.field_value?.src
                        }
                      />
                    </div>
                  </Box>
                </Grid>
                {isMobile && free_shipping_text?.field_value && (
                  <Box paddingX={2} className={classes.free_shipping_text}>
                    {free_shipping_text?.field_value}
                  </Box>
                )}
                <Grid item xs={12} md={6}>
                  <Box p={{ xs: 2, md: 8 }}>
                    <Box display="flex" flexDirection="column">
                      {!isMobile && (
                        <Box
                          paddingY={2}
                          style={{ borderBottom: "1px solid #f2f2f2" }}
                        >
                          <Box className={classes.descTitle}>
                            {package_title.field_value}
                          </Box>
                          {package_subtitle?.field_value && (
                            <Box className={classes.descSubTitle}>
                              {package_subtitle.field_value}
                            </Box>
                          )}
                          {free_shipping_text?.field_value && (
                            <Box className={classes.free_shipping_text}>
                              {free_shipping_text?.field_value}
                            </Box>
                          )}
                        </Box>
                      )}
                      {(item?.field_value || []).map((element, index) => (
                        <div key={index}>
                          <Box
                            paddingY={2}
                            borderBottom={1}
                            style={{ borderBottom: "1px solid #f2f2f2" }}
                          >
                            <Box
                              display="flex"
                              flexDirection="row"
                              justifyContent={"space-between"}
                              gridGap={4}
                            >
                              <Box className={classes.deliveryText}>
                                {element.field_value.product_title.field_value}
                              </Box>
                              <Box>
                                <Box
                                  textAlign="right"
                                  mb={1}
                                  className={classes.deliveryTextSpecial}
                                >
                                  {
                                    element.field_value.product_discount_text
                                      .field_value
                                  }
                                </Box>
                                <Box>
                                  {element.field_value.product_real_price
                                    .field_value ? (
                                    <Box className={classes.priceContainer}>
                                      {element.field_value
                                        .product_original_price.field_value && (
                                        <strike>
                                          {
                                            element.field_value
                                              .product_original_price
                                              .field_value
                                          }
                                        </strike>
                                      )}
                                      <Text style={{ fontWeight: 600 }}>
                                        {
                                          element.field_value.product_real_price
                                            .field_value
                                        }
                                      </Text>
                                    </Box>
                                  ) : (
                                    <Box>
                                      {
                                        element.field_value
                                          .product_original_price.field_value
                                      }
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </div>
                      ))}
                      {!isMobile &&
                        (button_cta?.field_value?.product_code ||
                          button_cta?.field_value?.href) && (
                          <Box paddingY={4}>
                            <CtaButton
                              next
                              size="large"
                              {...button_cta?.field_value}
                              className={classes.ctaButton}
                              trackingObj="PDP"
                              trackingAction="package-module"
                              trackingLabel={repo?.title}
                            >
                              {button_cta.field_value.label}
                            </CtaButton>
                          </Box>
                        )}
                      {disclaimer?.field_value && (
                        <Box paddingY={2}>
                          <Text
                            className={classes.disclaimer}
                            dangerouslySetInnerHTML={{
                              __html: disclaimer.field_value,
                            }}
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </>
      </VisibilitySensor>
    </Module>
  )
}

PackageV3Module.defaultProps = {
  image: {
    field_type: "image",
    field_value: { alt: "", title: "", src: "" },
  },
  image_mobile: {
    field_type: "image",
    field_value: { alt: "", title: "", src: "" },
  },
  title: {
    field_type: "text",
    field_value: "",
  },
  package_title: {
    field_type: "text",
    field_value: "",
  },
  package_subtitle: {
    field_type: "text",
    field_value: "",
  },
  free_shipping_text: {
    field_type: "text",
    field_value: "",
  },
  disclaimer: {
    field_type: "wysiwyg",
    field_value: "",
  },
}

export default PackageV3Module
